export default {"src":"/_next/static/media/board_finkel.3b5617a0.svg","height":606,"width":707,"blurWidth":0,"blurHeight":0};